import $ from 'jquery';

const API_BASE_URL = process.env.VUE_APP_CGSI_API || 'https://uat.cgsi.com.sg/cgsi/api/v1/';

export const API = {
  // GET 请求
  get(url, data) {


    return new Promise((resolve, reject) => {
      $.ajax({
        url: `${API_BASE_URL}${url}`,
        method: 'GET',
        dataType: 'json',
        data: new URLSearchParams(data).toString(),
        success: resolve,
        error: reject
      });
    });
  },
    get1(url, data) {


    return new Promise((resolve, reject) => {
      $.ajax({
        url: `http://127.0.0.1:3030/cgsi/api/v1/${url}`,
        method: 'GET',
        dataType: 'json',
        data: new URLSearchParams(data).toString(),
        success: resolve,
        error: reject
      });
    });
  },

  // POST 请求
  post(url, data) {

    return new Promise((resolve, reject) => {
      $.ajax({
        url: `${API_BASE_URL}${url}`,
        method: 'POST',
        contentType: 'application/json',
        data: new URLSearchParams(data).toString(),
        success: resolve,
        error: reject
      });
    });
  },

  // PUT 请求
  put(url, data) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: `${API_BASE_URL}${url}`,
        method: 'PUT',
        contentType: 'application/json',
        data: new URLSearchParams(data).toString(),
        success: resolve,
        error: reject
      });
    });
  },

  // DELETE 请求
  delete(url) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: `${API_BASE_URL}${url}`,
        method: 'DELETE',
        success: resolve,
        error: reject
      });
    });
  }
};